import { PropsWithChildren } from "react";

import { cn } from "@utils/tailwind.util";

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  className?: string;
}

export function H3({ className, children }: PropsWithChildren<Props>) {
  return (
    <h3
      className={cn(
        "text-gray-950 dark:text-white text-center text-[16px] font-[600] leading-6 non-selectable",
        className
      )}
    >
      {children}
    </h3>
  );
}
